import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { handlePostRequest } from "../../services/PostTemplate";
import * as Yup from "yup";
import ZbizInput from "../../components/zbizInput/ZbizInput";
import classNames from "classnames";
import { Dropdown } from "primereact/dropdown";

const AddNewGateForm = ({ onCloseModal, getAllGates, companyId }) => {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("");

  const validationSchema = Yup.object().shape({
    gateName: Yup.string().required("This field is required."),
    inOut: Yup.string().required("This field is required."),
  });

  const GateOptions = [
    { label: "In", value: "In" },
    { label: "Out", value: "Out" },
  ];

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      gateName: "",
      inOut: "",
    },
    onSubmit: async (data) => {
      try {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");
        data["companyId"] = parseInt(companyId);
        await handlePostRequest(data, "gate/addNew");
        setloading(false);
        setloadingIcon("pi pi-save");
        getAllGates();
        onCloseModal();
      } catch (error) {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  return (
    <div className="card Card__Round">
      <div className="Form__Header">
        <h1> Add User </h1>
      </div>
      <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput
                required
                placeholder="Enter Name"
                label="Gate Name"
                keyName="gateName"
                {...props}
              />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <label
                htmlFor="inOut"
                className={classNames(
                  { "p-error": isFormFieldValid("inOut") },
                  "Label__Text"
                )}
              >
                In/Out<span className="Label__Required">*</span>
              </label>
              <Dropdown
                id="inOut"
                placeholder="Select In/Out"
                options={GateOptions}
                name="inOut"
                value={formik.values.inOut}
                onChange={formik.handleChange}
                className={classNames(
                  { "p-invalid": isFormFieldValid("inOut") },
                  "Dropdown__Round"
                )}
              />
              {getFormErrorMessage("inOut")}
            </div>
          </div>
        </div>

        <div className="Down__Btn">
          <Button
            disabled={loading}
            icon={loadingIcon || ""}
            iconPos="right"
            label={"Add"}
            className="Btn__Dark"
          />
        </div>
      </form>
    </div>
  );
};

export default AddNewGateForm;
